import React, { useEffect, useRef, useState } from 'react';
import Isotope from 'isotope-layout';
import FsLightbox from 'fslightbox-react';

const GalleryFilter = ({ 
  items = [], 
  categories = [], 
  defaultFilter = 'all',
  lightboxSources = []
}) => {
  const isotopeRef = useRef(null);
  const [isotope, setIsotope] = useState(null);
  const [filterKey, setFilterKey] = useState(defaultFilter);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  });

  // Initialize Isotope
  useEffect(() => {
    if (isotopeRef.current) {
      // Wait for images to load
      const images = isotopeRef.current.querySelectorAll('img');
      const imagePromises = Array.from(images).map(img => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to prevent hanging
          }
        });
      });

      Promise.all(imagePromises).then(() => {
        const iso = new Isotope(isotopeRef.current, {
          itemSelector: '.gallery-item',
          layoutMode: 'masonry',
          masonry: {
            columnWidth: '.gallery-item'
          },
          percentPosition: true
        });
        setIsotope(iso);
        
        // Force layout after initialization
        setTimeout(() => {
          iso.layout();
        }, 100);
      });
    }

    return () => {
      if (isotope) {
        isotope.destroy();
      }
    };
  }, []);

  // Filter items when filterKey changes
  useEffect(() => {
    if (isotope) {
      if (filterKey === 'all') {
        isotope.arrange({ filter: '*' });
      } else {
        isotope.arrange({ filter: `.${filterKey}` });
      }
    }
  }, [isotope, filterKey]);

  const handleFilterClick = (category) => {
    setFilterKey(category);
  };

  const openLightbox = (slideNumber) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: slideNumber
    });
  };

  return (
    <>
      <div className="sortable-masonry filter-gallery">
        <div className="filters clearfix">
          <ul className="filter-tabs filter-btns clearfix" style={{ padding: 0 }}>
            {categories.map((category) => (
              <li 
                key={category}
                className={`filter ${filterKey === category ? 'active' : ''}`}
                data-role="button"
                data-filter={`.${category}`}
                onClick={() => handleFilterClick(category)}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </li>
            ))}
          </ul>
        </div>

        <div className="items-container row clearfix" ref={isotopeRef}>
          {items.map((item, index) => (
            <div 
              key={index}
              className={`gallery-item masonry-item ${item.categories.join(' ')} col-lg-4 col-md-6 col-sm-12`}
            >
              <div className="gallery-block">
                <div className="inner-box">
                  <div className="image_g">
                    <img src={item.image} alt={item.alt || ''} title={item.title || ''} />
                  </div>
                  <a 
                    href={item.image} 
                    className="overlink lightbox-image" 
                    data-type="image" 
                    data-fslightbox="gallery-1"
                    onClick={(e) => {
                      e.preventDefault();
                      openLightbox(index + 1);
                    }}
                  >
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <FsLightbox
        toggler={lightboxController.toggler}
        slide={lightboxController.slide}
        sources={lightboxSources}
      />
    </>
  );
};

export default GalleryFilter;
